import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  TrackByFunction,
  ViewChild,
} from '@angular/core';
import { NgbNav, NgbNavChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import AppSettings from 'src/app/common/app.settings';
import { getStatusMark } from 'src/app/const/entity-view-constants';
import { RoleDisplayedInfo, UserBasicInfoContent } from 'src/app/interfaces/profile.interface';
import { FullUser } from '../../../../../swagger-api';
import { MapFilters } from '../../../../map/map.enum';
import { UserType, userTypeNameToEnum } from '../../../profile.enum';

@Component({
  selector: 'app-user-basic-info',
  templateUrl: './user-basic-info.component.html',
  styleUrls: ['./user-basic-info.component.scss'],
})
export class UserBasicInfoComponent implements AfterViewInit, OnChanges {
  @Input({ required: true }) public content: UserBasicInfoContent;
  @Input({ required: true }) public locationUser: string;
  @Input({ required: true }) public user: FullUser;

  @Output() public activeTabChanged: EventEmitter<UserType> = new EventEmitter<UserType>();

  public readonly NO_PHOTO_DEFAULT_IMAGE = AppSettings.NO_PHOTO_DEFAULT_IMAGE;
  public readonly trackByRole: TrackByFunction<RoleDisplayedInfo> = (_index, roleInfo) => roleInfo.userType;

  public activeId: string | null = null;
  public isHiddenUserData = true;
  public additionalTitle?: string;

  @ViewChild('nav', { static: false }) public nav: NgbNav;

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['content'] && !this.isEmptyContentData) {
      this.activeId = this.content.data.at(0).userType;
    }

    if (changes['user'] || changes['content']) {
      this.setupUserDataVisibility();
    }
  }

  public ngAfterViewInit(): void {
    if (this.nav && !this.isEmptyContentData) {
      this.activeTabChanged.emit(userTypeNameToEnum(this.nav.activeId as string));
    }
  }

  public getStatusMark(): string {
    return getStatusMark(this.content.status);
  }

  public onActiveTabChanged(event: NgbNavChangeEvent<string>): void {
    this.activeTabChanged.emit(userTypeNameToEnum(event.nextId));
  }

  private get isEmptyContentData(): boolean {
    return this.content.data == null || this.content.data.length == 0;
  }

  private setupUserDataVisibility(): void {
    const isUncompletedOrganization = this.content.isOrganization === true && !this.user.profile.location;
    this.isHiddenUserData = this.isEmptyContentData || isUncompletedOrganization;
    this.additionalTitle = isUncompletedOrganization ? 'USER_ORGANIZATION_TITLE' : null;
  }

  protected readonly mapFilters = MapFilters;
}
